import { Button, Typography, message } from 'antd'
import QRCode from 'qrcode.react'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import LoadingPage from '../../components/LoadingPage'
import config from '../../config'
import { getReservationInfo } from '../../services/BookingChecking/bookingCheckin.service'

const { Text } = Typography

const BookingQRCheckin = (): JSX.Element => {
  const [matches, setMatches] = useState(window.matchMedia('(min-width: 768px)').matches)
  const [loading, setLoading] = useState(true)
  const [qrUrl, setQrUrl] = useState<string | null>(null)
  const location = useLocation()
  // Extract token from URL parameters
  const getTokenFromUrl = () => {
    const params = new URLSearchParams(location.search)
    return params.get('token')
  }

  const token = getTokenFromUrl()

  //landscape tablet break point
  useEffect(() => {
    window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => setMatches(e.matches))
  }, [])

  // Fetch reservation info and generate QR code
  useEffect(() => {
    const fetchReservationInfo = async () => {
      try {
        if (!token) {
          message.error('Missing token in URL parameters')
          setLoading(false)
          return
        }

        // Fetch reservation info using token
        const response = await getReservationInfo(token)

        if (response.result?.reservationData?.reservationno) {
          // Generate QR URL
          const generatedQrUrl = `${config.cmsService.URL}/reservation/${response.result.reservationData.reservationno}/checkin`
          setQrUrl(generatedQrUrl)
        } else {
          message.error('Reservation number not found')
        }
      } catch (error) {
        message.error('Failed to load reservation information')
      } finally {
        setLoading(false)
      }
    }

    fetchReservationInfo()
  }, [location.search])

  if (loading) {
    return <LoadingPage />
  }

  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: '#0048B3',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            height: '43px',
            width: matches ? '98%' : '100%',
            backgroundColor: '#1D2530',
            display: 'flex',
            alignItems: 'center',
            marginTop: matches ? '2rem' : 0,
          }}
        >
          <Text
            style={{
              color: '#fff',
              fontSize: '11px',
              marginLeft: '2rem',
            }}
          >
            {matches ? 'Booking QR Check-in' : 'QR Check-in'}
          </Text>
        </div>

        <div
          style={{
            width: matches ? '80%' : '90%',
            marginTop: '1rem',
            backgroundColor: '#003C92',
            display: matches ? 'flex' : '',
            flexWrap: matches ? 'wrap' : 'nowrap',
            justifyContent: matches ? 'center' : '',
            height: matches ? '' : '90%',
            borderRadius: matches ? '10px' : '20px',
            paddingBottom: matches ? '2rem' : 0,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: matches ? 'row' : 'column',
              justifyContent: matches ? 'center' : 'start',
            }}
          >
            <div
              style={{
                width: matches ? '45%' : '100%',
                height: 300,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
            >
              {matches && (
                <div>
                  <Text
                    style={{
                      color: '#FBD50E',
                      fontSize: '15px',
                    }}
                  >
                    Show QR code to staff for quick check-in.
                  </Text>
                </div>
              )}

              {/* QR Code Display */}
              {qrUrl ? (
                <div
                  style={{
                    backgroundColor: 'rgb(255, 255, 255)',
                    padding: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <QRCode
                    value={qrUrl}
                    size={matches ? 170 : 200}
                    bgColor="rgb(255, 255, 255)"
                    fgColor="rgb(0, 0, 0)"
                  />
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: 'rgb(255, 255, 255)',
                    padding: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: matches ? 190 : 220,
                    height: matches ? 190 : 220,
                  }}
                >
                  <div
                    style={{
                      width: matches ? 170 : 200,
                      height: matches ? 170 : 200,
                      backgroundColor: '#f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      color: '#666',
                      textAlign: 'center',
                      border: '1px dashed #999',
                    }}
                  >
                    QR Code
                    <br />
                    Loading...
                  </div>
                </div>
              )}

              <div
                style={{
                  width: matches ? '60%' : '70%',
                  textAlign: 'center',
                }}
              >
                <Text
                  style={{
                    fontSize: '9px',
                    color: '#fff',
                  }}
                >
                  Please present this QR code for quick booking check-in process and verification.
                </Text>
              </div>
            </div>

            {matches && (
              <div
                style={{
                  height: '90%',
                  width: '2%',
                  marginRight: '2%',
                  borderRight: '0.5px solid #fff',
                }}
              ></div>
            )}

            <div
              style={{
                width: matches ? '45%' : '100%',
                height: matches ? 300 : 350,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
            >
              {matches && (
                <div>
                  <Text
                    style={{
                      color: '#FBD50E',
                      fontSize: '15px',
                    }}
                  >
                    Complete check-in process online.
                  </Text>
                </div>
              )}

              <div
                style={{
                  width: '80%',
                  textAlign: matches ? 'start' : 'center',
                }}
              >
                <Text
                  style={{
                    fontSize: matches ? '15px' : '17px',
                    color: '#fff',
                    fontWeight: '600',
                  }}
                >
                  Complete your booking check-in quickly and efficiently.
                </Text>
              </div>

              <div
                style={{
                  width: '80%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Link
                  to={`/reservation-booking?token=${token}`}
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    textDecoration: 'none',
                  }}
                >
                  <Button type="primary" style={{ width: matches ? '100%' : '60%' }}>
                    Back to Check-in
                  </Button>
                </Link>
              </div>

              <div
                style={{
                  width: matches ? '60%' : '70%',
                  textAlign: 'center',
                }}
              >
                <Text style={{ fontSize: '11px', color: '#ffffff', fontWeight: 100 }}>
                  Proceed with the online check-in process to verify your documents and complete
                  your booking.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BookingQRCheckin
